/**
 * 接口文档地址
 */
export default [
  {
    /*
     * 发送注册短信验证码
     * http://10.222.95.129/#/view/aBXgyE2G
     */
    name: 'registerSms',
    method: 'post',
    url: '/auth/page/register/noAuth/registerSms',
  },
  {
    /*
     * 注册
     * http://10.222.95.129/#/view/ZB2lyd8D
     */
    name: 'register',
    method: 'post',
    url: '/auth/page/register/noAuth/register',
  },
  {
    /*
     * 邀请码提交
     * http://10.222.95.129/#/view/ZB2lyd8D
     */
    name: 'invite',
    method: 'post',
    url: '/auth/regist/invite/inviteCodeValidate',
  },
]
